import { Base } from './base.model';

export class AcrVintage extends Base {
  public acrReportingPeriodId: number;
  public vintageYear: number;
  public expectedIssuance: number;
  public actualIssuance: number;
}
